// extracted by mini-css-extract-plugin
export default {"list":"list_list__Mcd2e","list-container":"list_list-container__h-ayl","h1":"list_h1__fjdM5","loading":"list_loading__chvwd"};